import store from 'store2'
import React, { FC, useContext, useEffect, useState } from 'react'
import { NotificationsContext } from '~/service/Notifications'
import Tippy from '@tippyjs/react'

type NotificationsPromptButtonProps = {}

export const NotificationsPromptAlert: FC = ({}) => {
  const notificationsContext = useContext(NotificationsContext)

  const [notifyClosed, setNotifyClosed] = useState(
    !!store.get('notificationPromptClosed')
  )

  const [permission, setPermission] =
    useState<NotificationPermission>('granted')

  const [deniedAlert, setDeniedAlert] = useState(false)

  useEffect(() => {
    notificationsContext.notificationsCheck().then(setPermission)
  }, [])

  if (permission == 'granted' || notifyClosed) {
    return null
  }

  return (
    <div className="notificationsPrompt-alert">
      <button
        className="delete"
        onClick={() => {
          if (!deniedAlert) {
            store.set('notificationPromptClosed', '1')
          }

          setNotifyClosed(true)
        }}
      />
      {!deniedAlert ? (
        <>
          <div>{intl.formatMessage({ id: 'notification prompt / desc' })}</div>
          <div>
            <button
              className="button is-small is-dark"
              onClick={() => {
                if (permission == 'denied') {
                  setDeniedAlert(true)
                } else {
                  notificationsContext
                    .notificationsAsk()
                    .then()
                    .then(setPermission)
                }
              }}
            >
              {intl.formatMessage({ id: 'notification prompt / button' })}
            </button>
          </div>
        </>
      ) : (
        <div>{intl.formatMessage({ id: 'notification prompt / denied' })}</div>
      )}
    </div>
  )
}

export const NotificationsPromptButton: FC<
  NotificationsPromptButtonProps
> = ({}) => {
  const notificationsContext = useContext(NotificationsContext)

  const [permission, setPermission] =
    useState<NotificationPermission>('granted')

  useEffect(() => {
    notificationsContext.notificationsCheck().then(setPermission)
  }, [])

  if (permission == 'granted') {
    return null
  }

  const notification = () => {
    if (permission == 'denied') {
      alert(intl.formatMessage({ id: 'notification prompt / denied' }))
    } else {
      notificationsContext.notificationsAsk().then().then(setPermission)
    }
  }

  return (
    <Tippy
      content={intl.formatMessage({ id: 'notification prompt / desc' })}
      delay={500}
    >
      <button onClick={notification}>
        <span className="far fa-bell" />
      </button>
    </Tippy>
  )
}
